module.exports = __webpack_public_path__ + "img/Neill_Icon.4a60742a.png";